<template>
  <div class="timeLine">
    <div class="tl_title" @click="detail()">
      <img src="@/assets/images/digitalIcon_0.png" class="tl_title_icon" alt v-if="type == 0"/>
      <img src="@/assets/images/digitalIcon_1.png" class="tl_title_icon" alt v-else-if="type == 1"/>
      <div class="tl_title_name">{{ title }}</div>
      <div class="tl_title_more">
        <img class="tl_title_more__img" src="@/assets/images/more.png" alt />
      </div>
    </div>
    <div class="tl_content">
      <el-timeline v-if="type == 0">
        <el-timeline-item
          v-for="(info, index) in item.slice(0, 5)"
          :key="index"
          color="#689BFF"
          size="large"
          placement="bottom"
          :timestamp="info.TimeDesc"
        >
          <div @click="detail()">
            <div class="content" style="margin: 0 0 0 -0.5em;">【{{ info.Company }}】{{ info.Title }}</div>
            <div
              style="
                color: #d20000;
                line-height: 1.5em;
                font-size: 14px;
              "
            >
              薪资范围：{{ info.Salary }}
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>

      <el-timeline v-else-if="type == 1">
        <el-timeline-item
          v-for="(info, index) in item.slice(0, 15)"
          :key="index"
          color="#689BFF"
          size="large"
          placement="bottom"
        >
          <div
            class="content"
            style="display: flex; align-items: center"
            @click="detail()"
          >
            <div :class="getColorClass(index)">{{ index + 1 }}</div>
            <div class="content_title">{{ info.Title }}</div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { Timeline, TimelineItem } from "element-ui";
import Vue from "vue";
Vue.use(Timeline).use(TimelineItem);
export default {
  name: "timeLine",
  props: {
    item: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  methods: {
    // 时间戳处理
    parseDateFull(timestamp) {
      if (!timestamp) return "";
      let x = new Date(timestamp);
      let z = {
        y: x.getFullYear(),
        M: x.getMonth() + 1,
        d: x.getDate(),
        h: x.getHours(),
        m: x.getMinutes(),
        s: x.getSeconds(),
      };
      if (z.M < 10) {
        z.M = "0" + z.M;
      }
      if (z.d < 10) {
        z.d = "0" + z.d;
      }
      if (z.h < 10) {
        z.h = "0" + z.h;
      }
      if (z.m < 10) {
        z.m = "0" + z.m;
      }
      return z.y + "-" + z.M + "-" + z.d + " " + z.h + ":" + z.m;
    },
    // 全部信息
    detail() {
      var that = this;
      if (that.type == 0) {
        window.open("https://hitajobs.com/", "_blank");
      } else if (that.type == 1) {
        window.open("http://www.web3daily.news", "_blank");
      }
    },
    // 招聘详情
    jobDetail(info) {
      var that = this;
      if (that.type == 0) {
        const url = "https://hitajobs.com/jobs/" + info.Slug + ".html";
        window.open(url, "_blank");
      } else if (that.type == 1) {
        const url =
          "http://www.web3daily.news/informationDetail?id=" + info.articleId;
        window.open(url, "_blank");
      }
    },
    getColorClass(index) {
      if (index < 3) {
        return "ranking_1";
      } else {
        return "ranking_2";
      }
    },
  },
  beforeMount() {},
};
</script>

<style lang="scss" scoped>
.timeLine {
  width: 376px;
  height: auto;
  background: #f9fbfe;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #eaeff9;

  .tl_title {
    width: calc(100% - 50px);
    height: 59px;
    border-radius: 0px 0px 0px 0px;
    padding: 0 25px 0 25px;

    font-family: Inter, Inter;
    font-weight: 550;
    font-size: 20px;
    color: #000000;
    line-height: 59px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .tl_title_more {
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0 0 0;

      &__img {
        width: 60px;
        height: 28px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    .tl_title_name {
      width: calc(100% - 115px);
      height: 100%;
      margin: 0 0 0 10px;
    }

    .tl_title_icon {
      width: 25px;
      height: 100%;
      object-fit: contain;
    }
  }

  .tl_content {
    padding: 5px 25px 0 25px;

    .content {
      line-height: 1.5em;
      text-align: left;
      font-style: normal;
      font-size: 16px;
      color: #353535;

      .ranking_1 {
        width: 24px;
        height: 24px;
        background: #dd2905;
        border-radius: 4px 4px 4px 4px;

        font-weight: normal;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 0 12px 0 0;
      }
      .ranking_2 {
        width: 24px;
        height: 24px;
        background: #7998c8;
        border-radius: 4px 4px 4px 4px;

        font-weight: normal;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 0 12px 0 0;
      }
      .content_title {
        width: calc(100% - 36px);
        font-size: 14px;
        font-weight: normal;

        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        max-height: 4.5em;
        line-height: 1.5em;
      }
    }

    .content:hover {
      color: rgba(104, 155, 255, 1);
    }
  }
}
.el-timeline {
  width: 100%;
  height: 100%;

  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .el-timeline-item {
    width: 100%;
    height: auto;
    padding: 0 0 18px 0;
    line-height: 1.5em;
    margin: 0 0 0 0;

    cursor: pointer;

    /deep/.el-timeline-item__tail {
      display: none !important;
    }

    /deep/.el-timeline-item__node {
      display: none !important;
    }

    /deep/.el-timeline-item__wrapper {
      padding: 0 0 0 0 !important;
    }
    /deep/.el-timeline-item__timestamp {
      margin: 0px 0 0 0;
      line-height: 1.5em;
    }
  }
}
</style>